import { cacheExchange } from '@urql/exchange-graphcache';
import keys from '@/client/exchanges/cacheExchange/keys';
import mutation_root from '@/client/exchanges/cacheExchange/mutation';
import optimistic from '@/client/exchanges/cacheExchange/optimistic';
import resolvers from '@/client/exchanges/cacheExchange/resolvers';
import subscription_root from '@/client/exchanges/cacheExchange/subscription';
import cursorPaginationFn from './cursorPagination';

export function createCacheExchange() {
  return cacheExchange({
    schema: {
      __schema: {
        queryType: {
          name: 'query_root',
        },
        mutationType: {
          name: 'mutation_root',
        },
        subscriptionType: {
          name: 'subscription_root',
        },
      },
    },
    resolvers,
    updates: {
      subscription_root,
      mutation_root,
    },
    keys,
    optimistic,
    directives: {
      cursorPagination: (options) => cursorPaginationFn(options ?? {}),
    },
  });
}

export default createCacheExchange();
